import React from 'react';

import { FACEBOOK } from 'scenes/CustomAudiences/constants';

import {
  useBatchCreateLookalikeAudience,
  useBatchCreateCampaignBasedLookalikeAudiences,
} from '../../data';
import CampaignBasedLookalikeAudienceForm from './CampaignBasedLookalikeAudienceForm';
import LookalikeAudienceForm from './LookalikeAudienceForm';
import {
  TARGETING,
  ENTRIES,
  TYPE,
  PARTNER,
  TYPE_PARTNER_AUDIENCE_BASED,
  TYPE_CAMPAIGN_BASED,
  PARTNER_AUDIENCE,
} from './constants';

export { PARTNER, PARTNER_AUDIENCE };

export const LookalikeAudiencePartnerAudienceBasedFormCreate = ({
  initialValues: initialValuesExtends = {},
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [createBatchLookalikeAudiences, { isLoading: isCreating }] =
    useBatchCreateLookalikeAudience();

  const { [PARTNER]: partner = FACEBOOK, ...targeting } = initialValuesExtends;
  const initialValues = {
    [TYPE]: TYPE_PARTNER_AUDIENCE_BASED,
    [PARTNER]: partner,
    [TARGETING]: targeting,
  };
  const handleSubmit = async (values = {}) => {
    const response = await createBatchLookalikeAudiences(values[ENTRIES]);
    onSubmit(response);
  };

  return (
    <LookalikeAudienceForm
      title={'Add Lookalike Audience'}
      loading={isCreating}
      onClose={onClose}
      onExited={onExited}
      open={open}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    />
  );
};

export const LookalikeAudienceCampaignBasedFormCreate = ({
  initialValues: initialValuesExtends = {},
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [createCampaignBasesLookalikes, { isLoading }] =
    useBatchCreateCampaignBasedLookalikeAudiences();
  const { [PARTNER]: partner = FACEBOOK, ...targeting } = initialValuesExtends;

  const initialValues = {
    [TYPE]: TYPE_CAMPAIGN_BASED,
    [PARTNER]: partner,
    [TARGETING]: targeting,
  };

  const handleSubmit = async (values = {}) => {
    const response = await createCampaignBasesLookalikes(values[ENTRIES]);
    onSubmit(response);
  };

  return (
    <CampaignBasedLookalikeAudienceForm
      title={'Add Campaign Based Lookalike Audience'}
      initialNormalized={false}
      loading={isLoading}
      onClose={onClose}
      onExited={onExited}
      open={open}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    />
  );
};
